<template>
  <div
    ref="background"
    :class="{ modal: true, visible, ['modal-animation-' + animation]: true }"
    @click="onBackgroundClick"
  >
    <div ref="modal" class="modal-body-container">
      <slot name="icon"></slot>

      <div class="modal-body">
        <div class="modal-scroll">
          <div
            v-if="showClose"
            ref="close"
            @click="onClose"
            class="modal-close"
          ></div>
          <button
            class="modal-action"
            ref="action"
            @click="onAction"
            v-if="!showClose"
          >
            {{ actionText }}
          </button>
          <div class="modal-content">
            <slot></slot>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    closeOnOutsideClick: {
      type: Boolean,
      default: true
    },
    showClose: {
      type: Boolean,
      default: true
    },
    actionText: {
      type: [Boolean, String],
      default: false
    }
  },

  data() {
    return {
      visible: false,
      animation: null
    };
  },

  mounted() {
    this.$refs.background.addEventListener("click", this.onBackgroundClick);
    this.$refs.modal.addEventListener("click", this.onModalClick);

    this.updateVisiblity();
  },

  beforeDestroy() {
    this.$refs.background.removeEventListener("click", this.onBackgroundClick);
    this.$refs.modal.removeEventListener("click", this.onModalClick);
    document.body.style.overflow = "auto";
  },

  methods: {
    onClose() {
      this.$emit("input", false);
    },

    onAction() {
      this.$emit("action");
    },

    onModalClick(e) {
      e.stopPropagation();
    },

    onBackgroundClick(e) {
      e.stopPropagation();

      if (this.closeOnOutsideClick) {
        this.onClose();
      }
    },

    updateVisiblity() {
      if (this.value && !this.visible) {
        this.visible = true;
        document.body.style.overflow = "hidden";

        setTimeout(() => {
          this.animation = "in";
        }, 30);
      } else if (!this.value && this.visible) {
        this.animation = "out";

        setTimeout(() => {
          this.visible = false;
          document.body.style.overflow = "auto";
        }, 400);
      }
    }
  },

  watch: {
    value() {
      this.updateVisiblity();
    }
  }
};
</script>

<style lang="scss" scoped>
.modal-icon {
  position: absolute;
  top: -43px;
  left: 50%;
  transform: translateX(-50%);
  height: 86px;
  width: 86px;
  border: 5px solid #ffffff;
  background: radial-gradient(circle, #32c5ff 0%, #1798cb 100%);
  box-shadow: 0 12px 30px 0 rgba(64, 64, 92, 0.2);
  border-radius: 50%;
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-body-container {
  position: relative;
}
</style>
